<!-- Residential listing search box used on the homepage, footer CTA, and general content pages. -->
<template>
  <div class="search-input-container">
    <input type="text" v-model="value" @keydown.enter="search"
           class="search-input" :placeholder="placeholder"
           aria-label="Search input">
    <button @click="search" class="search-input-button icon-m-search"
            aria-label="Search"></button>
  </div>
</template>

<script>
export default {
  emits: [],
  props: {
    placeholder: {
      type: String,
      default: 'Search by address, zip, mls #, subdivision, or city'
    }
  },
  data() {
    return {
      value: ''
    };
  },
  methods: {
    search() {
      const encodedSearch = encodeURI(this.value);
      const endpointUrl =
          window.location.origin + '/listings?q=' + encodedSearch;

      window.location = endpointUrl;
    }
  }
};
</script>
